"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.precisionRound = void 0;
var precisionRound = function precisionRound(number, precision) {
  return Math.round(number * Math.pow(10, precision)) / Math.pow(10, precision);
}; // eslint-disable-line import/prefer-default-export

exports.precisionRound = precisionRound;